import { IAccessRight } from '@agilepoint/wat';
import { PermissionCode } from './permissions';

export enum AccessRightKeys {

}

export const accessRights: IAccessRight<PermissionCode>[] = [

];
